import { LoadingState } from "../../states/loading.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-elements-library";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/theme";
import { createFeedHelpers } from "../helpers/feedHelpers.js";
import { createDisplayHandlers } from "../helpers/displayHandler.js";
import { createFetchHandlers } from "../helpers/fetchHandler.js";
function createBaseFeed(config) {
  const {
    token,
    isThemeDark = false,
    isTransparent = false,
    isOverlay = false,
    isAligned = false,
    cardType,
    numberOfColumnsToShow = 1,
    numberOfRowsToStart,
    isLazyLoad = false,
    enableCategoryFallback = false,
    categories,
    ids,
    entriesToRemove,
    fetchStrategy,
    displayStrategy,
    layoutStrategy,
    noResultsConfig,
    imageConfig,
    // Collect strategy-specific props (e.g. isUnion, isMediaTrained)
    ...strategyProps
  } = config;
  const container = document.createElement("div");
  const loading = new LoadingState({ isThemeDark });
  let styles = loading.styles;
  const helpers = createFeedHelpers({
    container,
    initialStyles: styles
  });
  const originalSetStyles = helpers.setStyles;
  helpers.setStyles = (additionalStyles) => {
    styles += additionalStyles;
    originalSetStyles(additionalStyles);
  };
  const shadowRootCallback = (shadow) => {
    helpers.setShadowRoot(shadow);
  };
  const cardMappingOptions = {
    isThemeDark,
    isTransparent,
    isOverlay,
    isAligned,
    imageConfig,
    ...cardType && { cardType }
  };
  const layoutElement = layoutStrategy.create({
    columns: numberOfColumnsToShow,
    isThemeDark
  });
  helpers.setStyles(layoutElement.styles);
  const baseProps = {
    token,
    categories,
    ids,
    entriesToRemove,
    numberOfColumnsToShow,
    numberOfRowsToStart,
    isLazyLoad,
    getOffset: helpers.getOffset,
    ...strategyProps
  };
  const lazyLoadCallbackRef = {
    current: void 0
  };
  const displayHandlers = createDisplayHandlers({
    displayStrategy,
    layoutStrategy,
    helpers,
    cardMappingOptions,
    isLazyLoad,
    numberOfColumnsToShow,
    numberOfRowsToStart,
    noResultsConfig: {
      ...noResultsConfig,
      isThemeDark
      // Ensure theme is passed to EmptyState
    },
    // Pass a function that calls the current callback
    lazyLoadCallback: isLazyLoad ? async () => {
      if (lazyLoadCallbackRef.current) {
        await lazyLoadCallbackRef.current();
      }
    } : void 0
  });
  const fetchHandlers = createFetchHandlers({
    fetchStrategy,
    helpers,
    baseProps,
    displayHandlers,
    layoutElement,
    isThemeDark,
    enableCategoryFallback
  });
  lazyLoadCallbackRef.current = fetchHandlers.loadMore;
  container.appendChild(loading.element);
  fetchHandlers.start();
  return {
    element: container,
    get styles() {
      return styles;
    },
    events: {
      callback: shadowRootCallback
    }
  };
}
export {
  createBaseFeed
};
//# sourceMappingURL=createBaseFeed.js.map
